export const HourGlass = () => (
  <svg width="38" height="42" viewBox="0 0 38 42" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.17082 13.2324L5.56647 4.17067L1.57027 3.99619L1.74475 0L37.7105 1.5703L37.536 5.56649L33.5398 5.39201L33.1442 14.4537L22.4574 20.9234L32.5396 28.2998L32.144 37.3616L36.1402 37.536L35.9657 41.5322L-2.44975e-05 39.9619L0.174453 35.9657L4.17065 36.1402L4.56629 27.0785L15.2531 20.6088L5.17082 13.2324ZM9.30094 10.3394L9.56266 4.34515L29.5436 5.21754L29.2819 11.2118L9.30094 10.3394ZM28.3223 33.1909L28.4501 30.264L18.7504 23.1675L8.46911 29.3917L8.34132 32.3185L28.3223 33.1909Z"
      fill="#D0D0D4"
    />
  </svg>
)

export default HourGlass
